import { render } from "./Workinfo.vue?vue&type=template&id=c06a0a7a&scoped=true"
import script from "./Workinfo.vue?vue&type=script&lang=js"
export * from "./Workinfo.vue?vue&type=script&lang=js"

import "./Workinfo.vue?vue&type=style&index=0&id=c06a0a7a&scoped=true&lang=css"

import exportComponent from "/Users/hk/Omat tiedostot/koodit/htmljacss/hkvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06a0a7a"]])

export default __exports__